// Notification Types and Categories
export const NOTIFICATION_TYPES = {
  SYSTEM: "system",
  MEMBER: "member",
  MEMBERSHIP: "membership",
  LOAN: "loan",
  CONTRIBUTION: "contribution",
  PAYMENT: "payment",
  EVENT: "event",
  BRANCH: "branch",
  STAFF: "staff",
  GENERAL: "general",
  EMINUTE: "eminute",
  BIRTHDAY: "birthday",
  INVESTMENT: "investment",
  MARKETPLACE: "marketplace",
  REAL_ESTATE: "real_estate",
  KYC: "kyc",
  SECURITY: "security",
};

// Notification Categories with Icons and Colors
export const NOTIFICATION_CATEGORIES = {
  [NOTIFICATION_TYPES.SYSTEM]: {
    name: "System",
    icon: "/Icon/settings.svg",
    color: "#3E97B2",
    bgColor: "#E3F2FD",
  },
  [NOTIFICATION_TYPES.MEMBER]: {
    name: "Member",
    icon: "/Icon/member.svg",
    color: "#4CAF50",
    bgColor: "#E8F5E8",
  },
  [NOTIFICATION_TYPES.MEMBERSHIP]: {
    name: "Membership",
    icon: "/Icon/member.svg",
    color: "#4CAF50",
    bgColor: "#E8F5E8",
  },
  [NOTIFICATION_TYPES.LOAN]: {
    name: "Loan",
    icon: "/Icon/loan.svg",
    color: "#FF9800",
    bgColor: "#FFF3E0",
  },
  [NOTIFICATION_TYPES.CONTRIBUTION]: {
    name: "Contribution",
    icon: "/Icon/contribution.svg",
    color: "#9C27B0",
    bgColor: "#F3E5F5",
  },
  [NOTIFICATION_TYPES.PAYMENT]: {
    name: "Payment",
    icon: "/Icon/contribution.svg",
    color: "#19BC31",
    bgColor: "#ddfcdc",
  },
  [NOTIFICATION_TYPES.EVENT]: {
    name: "Event",
    icon: "/Icon/event.svg",
    color: "#E91E63",
    bgColor: "#FCE4EC",
  },
  [NOTIFICATION_TYPES.BRANCH]: {
    name: "Branch",
    icon: "/Icon/branch.svg",
    color: "#607D8B",
    bgColor: "#ECEFF1",
  },
  [NOTIFICATION_TYPES.STAFF]: {
    name: "Staff",
    icon: "/Icon/staff.svg",
    color: "#795548",
    bgColor: "#EFEBE9",
  },
  [NOTIFICATION_TYPES.GENERAL]: {
    name: "General",
    icon: "/Icon/notification.svg",
    color: "#2196F3",
    bgColor: "#E3F2FD",
  },
  [NOTIFICATION_TYPES.EMINUTE]: {
    name: "E-Minute",
    icon: "/Icon/eminute.svg",
    color: "var(--color-secondary)",
    bgColor: "#eaf1f4",
  },
  [NOTIFICATION_TYPES.BIRTHDAY]: {
    name: "Birthday",
    icon: "/Icon/notification.svg",
    color: "#ed49e0",
    bgColor: "#fce2fa",
  },
  [NOTIFICATION_TYPES.INVESTMENT]: {
    name: "Investment",
    icon: "/Icon/notification.svg",
    color: "#31778c",
    bgColor: "#eaf1f4",
  },
  [NOTIFICATION_TYPES.MARKETPLACE]: {
    name: "Marketplace",
    icon: "/Icon/notification.svg",
    color: "#0556e5",
    bgColor: "#e1ecfe",
  },
  [NOTIFICATION_TYPES.REAL_ESTATE]: {
    name: "Real Estate",
    icon: "/Icon/notification.svg",
    color: "#8b313a",
    bgColor: "rgba(139, 49, 58, 0.08)",
  },
  [NOTIFICATION_TYPES.KYC]: {
    name: "KYC",
    icon: "/Icon/member.svg",
    color: "#8543f1",
    bgColor: "#f3e5f5",
  },
  [NOTIFICATION_TYPES.SECURITY]: {
    name: "Security",
    icon: "/Icon/settings.svg",
    color: "#da6900",
    bgColor: "rgba(255, 149, 0, 0.12)",
  },
};

// Notification Priority Levels
export const NOTIFICATION_PRIORITY = {
  LOW: "low",
  MEDIUM: "medium",
  HIGH: "high",
  URGENT: "urgent",
};

// Priority Colors
export const PRIORITY_COLORS = {
  [NOTIFICATION_PRIORITY.LOW]: "#4CAF50",
  [NOTIFICATION_PRIORITY.MEDIUM]: "#FF9800",
  [NOTIFICATION_PRIORITY.HIGH]: "#F44336",
  [NOTIFICATION_PRIORITY.URGENT]: "#D32F2F",
};

// Notification Status
export const NOTIFICATION_STATUS = {
  UNREAD: "unread",
  READ: "read",
  ARCHIVED: "archived",
};

// Sample notification data structure
export const NOTIFICATION_SAMPLE = {
  id: 1,
  title: "New Member Registration",
  message: "John Doe has been registered as a new member",
  type: NOTIFICATION_TYPES.MEMBER,
  priority: NOTIFICATION_PRIORITY.MEDIUM,
  status: NOTIFICATION_STATUS.UNREAD,
  is_read: false,
  created_at: "2024-01-15T10:30:00Z",
  updated_at: "2024-01-15T10:30:00Z",
  read_at: null,
  user_id: 1,
  branch_id: 1,
  target_type: "branch", // "user" or "branch"
  target_id: 1,
  action_url: "/members/123",
  metadata: {
    member_id: 123,
    member_name: "John Doe",
    branch_name: "Main Branch",
  },
};

// Helper functions
export const getNotificationCategory = (type) => {
  return (
    NOTIFICATION_CATEGORIES[type] ||
    NOTIFICATION_CATEGORIES[NOTIFICATION_TYPES.GENERAL]
  );
};

export const getPriorityColor = (priority) => {
  return (
    PRIORITY_COLORS[priority] || PRIORITY_COLORS[NOTIFICATION_PRIORITY.MEDIUM]
  );
};

export const formatNotificationTime = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const diffInMinutes = Math.floor((now - date) / (1000 * 60));

  if (diffInMinutes < 1) return "Just now";
  if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
  if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}h ago`;
  if (diffInMinutes < 10080) return `${Math.floor(diffInMinutes / 1440)}d ago`;

  return date.toLocaleDateString();
};

export const getNotificationIcon = (type) => {
  const category = getNotificationCategory(type);
  return category.icon;
};

export const getNotificationColor = (type) => {
  const category = getNotificationCategory(type);
  return category.color;
};
